// Extracted from the `list.sources` namespace of en.ts so the (over-length) main translation file
// stays within the architecture-gate line ratchet. Spread back in under its original `list.sources`
// key in en.ts.
export const enListSources = {
	title: "Sources",
	search: "Search for a source",
	name: "Name",
	subtitle: "Choose which source you want to use",
	delete: {
		title: "Delete Source",
	},
	// The stateful Sources header dropdown (PREC-3703).
	dropdown: {
		add: "Add a source",
		viewAll: "View all sources",
		unnamed: "Untitled source",
	},
	// A Google Maps source's own row in the dropdown (PREC-4994).
	maps: {
		type: "Google Maps",
		status: {
			draft: "Draft",
			queued: "Queued",
			running: "Running",
			findingPeople: "Finding people",
			waiting: "Waiting",
			done: "Done",
			error: "Could not be run",
			unknown: "Unknown",
		},
		leadCount_one: "{{count}} lead",
		leadCount_other: "{{count}} leads",
		rerunAvailable: "Close Sources, then use Re-Run List in the list header to try again.",
		rerunRunning: "The list is running. Wait for it to finish before using Re-Run List.",
	},
};
